<template>
    <div>
        <template v-for="node, n in nodes">
            <img v-if="is_emote(node)" :src="image_src(node)" class="align-middle inline-block" :alt="node" :key="n"/>
            <template v-else-if="is_placeholder(node)">
              <span class="tags" :key="node">{{ node }}</span>
            </template>
            <template v-else> {{ node }}</template>
        </template>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import useTwitch from '@/Shared/useTwitch'

export default {
  components: {
    Icon,
  },
  props: ['preview_message'],
  data() {
    return { twitchApi: null }
  },
  created() {
    this.twitchApi = useTwitch()
    if (!this.twitchApi.state.emotes) this.twitchApi.fetchEmotes()
  },
  computed: {
    nodes() {
        return this.preview_message.split(' ')
    },
    emotes() {
        return (this.twitchApi && this.twitchApi.state.emotes) || {}
    },
  },
    methods: {
    is_emote(node) {
        if (this.emotes != null) {
          return node in this.emotes;
        } else {
          return false;
        }
    },
    image_src(node) {
        return this.emotes ? this.emotes[node] : undefined
    },
    is_placeholder(node) {
      if (/\$[*]?/.test(node)) {
        return 1;
      } else {
        return 0;
      }
      
    } 
  },
}
</script>
<style scoped>
span.tags {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 3px 0 3px;
  font-size: 12px;
  color: #555;
  text-decoration: none;
  text-shadow: 0 1px white;
  background: #fafafa;
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  border-color: #dadada #d2d2d2 #c5c5c5;
  border-radius: 3px 3px 3px 3px;
  background-image: -webkit-linear-gradient(top, #fcfcfc, #f0f0f0);
  background-image: -moz-linear-gradient(top, #fcfcfc, #f0f0f0);
  background-image: -o-linear-gradient(top, #fcfcfc, #f0f0f0);
  background-image: linear-gradient(to bottom, #fcfcfc, #f0f0f0);
  -webkit-box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7), 0 1px 2px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7), 0 1px 2px rgba(0, 0, 0, 0.05);
}
</style>
